module.exports = __webpack_public_path__ + "img/sperm.b9680f23.png";